// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const doublade: PokeData = {
  "id": 680,
  "name": "doublade",
  "height": 8,
  "weight": 45,
  "base_experience": 157,
  "types": [
    PokeType.STEEL,
    PokeType.GHOST
  ],
  "api_moves": [
    "swords-dance",
    "tackle",
    "slash",
    "fury-cutter",
    "pursuit",
    "metal-sound",
    "aerial-ace",
    "iron-defense",
    "power-trick",
    "night-slash",
    "shadow-sneak",
    "iron-head",
    "autotomize",
    "retaliate",
    "sacred-sword"
  ],
  "moves": [
    "tackle",
    "pursuit",
    "metal-sound",
    "aerial-ace",
    "iron-defense",
    "night-slash",
    "shadow-sneak",
    "lick",
    "soul-sacrifice",
    "shadow-ball",
    "spectral-snatch",
    "confuse-ray",
    "night-shade"
  ],
  "evolution_chain": {
    "id": 349,
    "item": null,
    "species": [
      {
        "name": "honedge",
        "order": 680,
        "types": [
          PokeType.STEEL,
          PokeType.GHOST
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "doublade",
        "order": 681,
        "types": [
          PokeType.STEEL,
          PokeType.GHOST
        ],
        "evolves_from_species_id": 679,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 35,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "aegislash",
        "order": 682,
        "types": [
          PokeType.STEEL,
          PokeType.GHOST
        ],
        "evolves_from_species_id": 680,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": {
              "name": "dusk-stone"
            },
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.USE_ITEM
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 79.25,
    "speed": 35,
    "ability_power": 110
  },
  "stat_changes": [],
  "catch_rate": 90,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
